import { Injectable } from '@angular/core';
import { CalAngularService } from '@cvx/cal-angular';
import { catchError, tap } from 'rxjs/operators';
import { AppConfig } from './app-config.service';
import { of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private expiryTime: number = 14 * 60 * 1000; // 14 minutes is api token cache expiry time
    private refreshBuffer: number = 1 * 60 * 1000; // Refresh 1 minutes before expiry

    refreshTokenPromise: any;
    private isRefreshing = false;
    constructor(private calService: CalAngularService) {
    }

    getToken(): string {
        return sessionStorage.getItem('accessToken') ?? '';
    }

    setToken(token: string): void {
        sessionStorage.setItem('accessToken', token);
    }

    refreshToken() {
        if (!this.isRefreshing) {
            this.isRefreshing = true;
            this.refreshTokenPromise = this.calService.getAADToken(AppConfig.settings.oidcScopes, true).pipe(
                tap((response: any) => {
                    this.isRefreshing = false;
                    this.setToken(response.accessToken);
                }),
                catchError((err: any) => {
                    this.isRefreshing = false;
                    return of(null);
                })
            );
        }

        return this.refreshTokenPromise;
    }
}
